<style scoped>
  .hero-holder > .header,
  .suggestion-holder > .header{
    height: 158px;
    display: flex;
    align-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
  }

  .hero-holder > .header > .image,
  .suggestion-holder > .header > .image{
    position: relative;
    height: 100%;
  }

  .hero-holder > .header > .image,
  .suggestion-holder > .header > .image{
        font-size: 3em;
    font-weight: 400;
  }

  .hero-holder > .content,
  .suggestion-holder > .content{
    text-align: center;
  }

  .login-holder{
    margin-top: 30px;
    text-align: center;
  }
</style>

<style>
  .report-modal-component .ivu-modal-header{
    padding: 0;
    border-bottom: 0;
  }
</style>


<template>
  <div class="report-modal-component">
    <ModalHolder title="" m-top="30" m-width="45%" m-height="62vh" :class-name="'report-modal-component'" :is-show="showModal">
      <template slot="mcontent">
        <div class="hero-holder" v-if="type == 'concern'">
          <div class="header flex-container direction-row center">
            <div class="image order-1" style="height:auto !important;">
              <!-- <img :src="rizal" style="height: 100%"/> -->
              <img :src="concern" style="height:120px;width:120px;"/>
            </div>
            <h1 class="order-3" style="width:100%" align="center">Report<br/>a Concern</h1>
            <img class="order-3" alt=" " @click="closeModal" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
          </div>
          <div class="content" style="font-size: 2.25vh;">
            <p>Do you have a complaint or a concern?</p>
            <p style="margin-top: 10px;">Report it to us here and we will make sure your concern is forwarded to the proper authorities.</p>
            <p style="margin-top: 10px;">A Sharpen Family Staff member may follow up with you for additional information.</p>
          </div>
        </div>
        <div class="hero-holder" v-if="type == 'hero'">
          <div class="header flex-container direction-row center">
            <div class="image order-1" style="height:auto !important;">
              <!-- <img :src="rizal" style="height: 100%"/> -->
              <img :src="rizal" style="height:120px;width:120px;"/>
            </div>
            <h1 class="order-3" style="width:100%" align="center">Nominate<br/>a Hero</h1>
            <img class="order-3" alt=" " @click="closeModal" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
          </div>
          <div class="content" style="font-size: 2.25vh;">
            <p>If you know someone who is quietly making a difference in the spirit of {{brandInfo.display_name}}, please share their story with us.</p>
            <p style="margin-top: 10px;">Be brief. We may follow up with a request for additional information, photos and maybe even an interview. There are heroes among us.</p>
            <p style="margin-top: 10px;">Please share their story.</p>
          </div>
        </div>
        <div class="suggestion-holder" v-if="type == 'suggestion'"></div>
        <div class="suggestion-holder" v-if="type == 'story'">
          <div class="header flex-container center">
            <div class="image order-1">
              <img :src="bulb" style="height:95%;width:135px;"/>
            </div>
            <h1 class="order-3" style="width:100%" align="center">Share<br/>a story</h1>
            <img class="order-3" alt=" " @click="closeModal" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
          </div>
          <div class="content" style="font-size: 2.25vh;">
            <p>Sharpen Family is looking for positive stories of people who have benefited from the current administration's programs or policies. If we do not tell these stories no one else will.</p>
            </br>
            <p style="margin-top: 10px;">Be brief, one of our staff writers  may call you for more details and maybe some pictures.</p>
            <!-- <p style="margin-top: 10px;">Be brief, if we like the idea, then we will forward to the proper authorities for follow-up. Or ew may even call you for an interview and share your idea here in the app.</p> -->
          </div>
        </div>
        <div class="login-holder" v-if="type == 'signup' || type == 'signin'">
          <img class="order-3" alt=" " @click="closeModal" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
          <div class="image">
            <img :src="tm"/>
          </div>
          <div class="desc" style="margin-top: 20px;">
            <p style="font-size: 2.25vh;">The Sharpen Family Alliance for the Philippines calls all the advocates of good governance and positive change to unite and cast our differences aside and work together towards a greater cause.</p>
          </div>
          <div class="action-buttons" style="display: flex;flex-direction: column;margin-top: 20px;">
            <Button type="primary" v-on:click="toSignUp()">test Register</Button>
            <Button type="primary" style="margin-top: 10px" @click="closeModal">Continue as Guest</Button>
            <p style="margin-top: 10px">Already a member? <a v-on:click="setMember('signin')">Log in</a></p>
          </div>
        </div>
      </template>
      <template slot="mfooter" v-if="type != 'signup' && type != 'signin'">
          <Button type="text" @click="closeModal">Cancel</Button>
          <Button type="primary" v-on:click="reRouteUrl(type)">Next</Button>
      </template>
    </ModalHolder>
  </div>
</template>

<script>
  import ModalHolder from "@/components/ModalHolderComponent";
  import VueCookie from 'vue-cookie'

  export default {
    name: 'WizardModalComponent',
    components: {
      ModalHolder
    },
    props: {
      type: {
        type: String,
        default: 'hero'
      }
    },
    mounted(){
      // console.log(this.type)
    },
    computed: {
      brandInfo() {
        return this.$store.getters["user/brandInfo"]
      },
      showModal: {
        get() {
          return this.$store.state.menu.showWizardModalComponent;
        }
      },
      rizal: {
        get() {
          return require('@/assets/rizal.jpg')
        }
      },
      bulb: {
        get() {
          return require('@/assets/share_story.jpg')
        }
      },
      concern: {
        get() {
          return require('@/assets/report_concern.png')
        }
      },
      tm: {
        get() {
          return require('@/assets/tm.png')
        }
      }
    },
    methods: {
      closeModal(){
        this.$store.commit('menu/setShowWizardModalComponent', false)
        this.$emit('closeModal')
      },
      reRouteUrl(type) {
        let reportConcernId = this.brandInfo.brand_default_groups.report_concern
        this.$router.push({ query: { post: reportConcernId, type: type }})
        // this.$store.commit('menu/setPostSelectionModal', false)
        this.closeModal()
        this.$store.commit('publicModule/setShowPostItemModal', true)
      },
      toSignUp() {
        this.$router.replace({path: '/step3?type=mobile'})
      },
      setMember(type) {
        let prescriptionCode =
          'code' in this.$route.query && this.$route.query.code
            ? this.$route.query.code
            : null
        let prescription =
          'prescription' in this.$route.query && this.$route.query.prescription
            ? this.$route.query.prescription
            : null
        let pType =
          'ptype' in this.$route.query && this.$route.query.ptype
            ? this.$route.query.ptype
            : null

        if (pType && prescription && prescriptionCode && type) {
          this.$router.replace({
            path:
              '/login?ptype=' +
              pType +
              '&type=' +
              type +
              '&prescription=' +
              prescription +
              '&code=' +
              prescriptionCode
          })
        } else if (!pType && !prescription && !prescriptionCode && type) {
          this.$router.replace({ path: '/login?type=' + type })
        } else if (!type && pType && prescriptionCode && prescription) {
          this.$router.replace({
            path:
              '/login?prescription=' +
              prescription +
              '&code=' +
              prescriptionCode +
              '&ptype=' +
              pType
          })
        } else this.$router.replace({ path: '/login' })
      }
    }
  }
</script>
